module.exports = __webpack_public_path__ + "static/img/ikona_film-ON.57e8f342.png";